export enum AuditScanResultType {
  OVERALL = 'overall',
  INDIVIDUAL = 'individual',
}
